(function(){
  function ready(fn){ if(document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function(){
    var button = document.querySelector('[data-valse-hamburger]');
    var panel = document.querySelector('[data-valse-mobile-panel]');
    var overlay = document.querySelector('[data-valse-mobile-overlay]');
    var closeBtn = document.querySelector('[data-valse-mobile-close]');
    if(!button || !panel || !overlay) return;

    function openMenu(){
      overlay.hidden = false;
      requestAnimationFrame(function(){
        button.classList.add('is-open');
        panel.classList.add('is-open');
        overlay.classList.add('is-open');
        button.setAttribute('aria-expanded','true');
        button.setAttribute('aria-label','Close mobile menu');
        panel.setAttribute('aria-hidden','false');
        document.documentElement.classList.add('valse-menu-lock');
        document.body.classList.add('valse-menu-lock');
      });
    }
    function closeMenu(){
      button.classList.remove('is-open');
      panel.classList.remove('is-open');
      overlay.classList.remove('is-open');
      button.setAttribute('aria-expanded','false');
      button.setAttribute('aria-label','Open mobile menu');
      panel.setAttribute('aria-hidden','true');
      document.documentElement.classList.remove('valse-menu-lock');
      document.body.classList.remove('valse-menu-lock');
      setTimeout(function(){ overlay.hidden = true; }, 300);
    }
    button.addEventListener('click', function(){ panel.classList.contains('is-open') ? closeMenu() : openMenu(); });
    overlay.addEventListener('click', closeMenu);
    if(closeBtn) closeBtn.addEventListener('click', closeMenu);
    panel.querySelectorAll('a').forEach(function(link){ link.addEventListener('click', closeMenu); });
    document.addEventListener('keydown', function(event){ if(event.key === 'Escape' && panel.classList.contains('is-open')) closeMenu(); });
  });
})();
